<template>
    <div>
        <div
            class="allInputBox border border-gray-600 rounded-full py-2 px-4 flex items-center h-10"
            :class="{'errorInputBox border-pink-800': error, 'bg-white': !error && !disabled, 'bg-gray-200': !error && disabled}"
        >
            <!--
                input
                @event input
                @property {String} $event.target.value
            -->        
            <!--
                離開焦點時進行事件觸發
                @event blur                                                                             
            -->    
            <!--
                按下鍵盤時觸發
                @event keydown                                                                            
            -->    
            <!--
                離開鍵盤時觸發
                @event keyup
                @property {Object} $event 事件對象
            -->                               
            <!--
                改變時觸發
                @event change       
            -->                                      
            <input
                :id="id"
                :ref="refName"
                v-uppercase="uppercase"
                v-trim="trim"
                :value="modelValue"
                :type="type"
                class="w-full text-[16px] outline-none placeholder-gray-600 bg-transparent opacity-100"
                :class="[{'text-pink-800': error, 'text-gray-900': !error, 'text-gray-600 cursor-not-allowed': disabled, 'no-spinner': type == 'number'}, inputclass]"
                :placeholder="placeholder"
                :disabled="disabled"
                :maxlength="maxLength"
                :autofocus="autofocus"
                @input="$emit('update:modelValue', $event.target.value)"
                @blur="$emit('blur')"
                @keydown="$emit('keydown')"
                @keyup="$emit('keyup', $event)"
                @change="$emit('change')"
            >
            <div
                v-if="suffix"
                class="text-[16px]"
            >
                {{ suffix }}
            </div>
        </div>

        <div
            v-if="message"
            class="my-1 text-[14px] text-gray-600"
        >
            {{ message }}
        </div>
        <div
            v-if="error && errorMessage"
            class="text-pink-800 text-[14px] flex justify-end items-center mt-1"
        >
            <div class="mr-2">
                <img
                    src="@/assets/images/icons/error.svg"
                    loading="lazy"
                    alt="close"
                >
            </div>

            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
/**
 * 表單-一般文字輸入框
 */
export default {
    name: 'FormTextField',
    props: {
        /**
         * 游標是否預設出現
         */
        autofocus: {
            type: Boolean,
            default: false
        },
        /**
         * 是否不能被點選，true：不可點選，false：可以點選
         */
        disabled: {
            type: Boolean,
            default: false
        },
        /**
         * 未輸入時顯示的文字
         */
        placeholder: {
            type: String,
            default: ''
        },
        /**
         * 文字內容
         */
        message: {
            type: String,
            default: ''
        },
        /**
         * 使用者輸入的文字內容
         */
        modelValue: {
            type: [String,Number],
            default: ''
        },
        /**
         * 後綴文字
         */
        suffix: {
            type: String,
            default: null
        },
        /**
         * 格式檢查是否有誤
         */
        error: {
            type: Boolean,
            default: false
        },
        /**
         * 錯誤訊息
         */
        errorMessage: {
            type: String,
            default: null
        },
        /**
         * 文字長度上限
         */
        maxLength: {
            type: Number,
            default: 999
        },
        /**
         * vue 裡面透過 ref 取得 input 的 DOM 物件進行操作，這裡是要使用 ref 取得 input 進行 autofocus 的操作
         */
        refName: {
            type: String,
            default: null
        },
        /**
         * input類型
         */
        type: {
            type: String,
            default: 'text'
        },
        /*顯示大寫 */
        uppercase: {
            type: Boolean,
            default: true
        },
        /*刪除前後空白 */
        trim: {
            type: Boolean,
            default: true
        },
        /**
         * input ID
         */
        id: {
            type: String,
            default: null
        },
        /**
         * Class名稱
         */
        inputclass: {
            type: String,
            default: null
        }
    },
    emits: ['update:modelValue', 'blur', 'keydown', 'keyup', 'change'],
    mounted() {
        // 如果有設定參考名稱
        if (this.refName) {
            // 游標自動顯示
            this.$refs[this.refName].focus();
        }
    }
};
</script>

<style scoped>
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spinner {
  -moz-appearance: textfield;
}
</style>
